import React from 'react';
import {
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  Folder as AllFoldersIcon,
  Add as AddIcon,
} from '@material-ui/icons';
import styles from './CategoriesSidebar.module.css';

// Derive a short status label for non-active links (shown next to the name).
const getLinkStatusLabel = (link) => {
  if (link.is_active === '0' || link.is_active === 0 || link.is_active === false) {
    return { text: 'Revoked', color: '#ef4444' };
  }
  if (link.is_expired) {
    return { text: 'Expired', color: '#f59e0b' };
  }
  return null;
};

const SharedSidebar = ({
  links = [],
  selectedLink,
  onLinkSelect,
  loading = false,
  onCreateFolder,
}) => {
  const handleLinkClick = (link) => {
    onLinkSelect(link);
  };

  const handleAllFoldersClick = () => {
    onLinkSelect(null);
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.menuList}>
        {/* All Folders Item - matches "All Videos" in CategoriesSidebar */}
        <div
          className={`${styles.menuItem} ${!selectedLink ? styles.active : ''}`}
          onClick={handleAllFoldersClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleAllFoldersClick();
            }
          }}
          style={{
            border: '2px dotted transparent',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          <AllFoldersIcon className={styles.menuIcon} />
          <div className={styles.menuContent}>
            <span className={styles.menuLabel}>All Folders</span>
            {!selectedLink && links.length > 0 && (
              <span className={styles.menuCount}>{links.length}</span>
            )}
          </div>
        </div>

        {/* Folder (Link) Items */}
        {loading ? (
          <div className={styles.loadingState}>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
          </div>
        ) : links.length === 0 ? (
          <div className={styles.emptyState}>
            <FolderIcon className={styles.emptyIcon} />
            <p>No folders found</p>
            {onCreateFolder && (
              <button
                type="button"
                className={styles.emptyCreateBtn}
                onClick={onCreateFolder}
              >
                <AddIcon />
                Create folder
              </button>
            )}
          </div>
        ) : (
          links.map((link, index) => {
            const isSelected = selectedLink?.uuid && selectedLink?.uuid === link.uuid;
            const displayName = link.label || 'Untitled Folder';
            const status = getLinkStatusLabel(link);
            const contributionCount = Number(link.contribution_count) || 0;
            return (
              <div
                key={link.uuid || link.id || index}
                className={`${styles.menuItem} ${isSelected ? styles.active : ''}`}
                onClick={() => handleLinkClick(link)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleLinkClick(link);
                  }
                }}
                style={{
                  border: '2px dotted transparent',
                  borderRadius: '8px',
                }}
              >
                {isSelected ? (
                  <FolderOpenIcon className={styles.menuIcon} />
                ) : (
                  <FolderIcon className={styles.menuIcon} />
                )}
                <div className={styles.menuContent}>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                    <span className={styles.menuLabel}>{displayName}</span>
                    {status && (
                      <span style={{ fontSize: '12px', color: status.color, fontWeight: 600 }}>
                        {status.text}
                      </span>
                    )}
                  </div>
                  {contributionCount > 0 && (
                    <span className={styles.menuCount}>{contributionCount}</span>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SharedSidebar;
